<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M17.6451 5.67682C18.0857 5.23634 18.3333 4.63888 18.3334 4.01587C18.3335 3.39285 18.086 2.79533 17.6456 2.35474C17.2051 1.91415 16.6076 1.66658 15.9846 1.6665C15.3616 1.66643 14.7641 1.91384 14.3235 2.35432L3.20182 13.4785C3.00833 13.6714 2.86524 13.9089 2.78515 14.1702L1.68432 17.7968C1.66278 17.8689 1.66115 17.9454 1.67961 18.0184C1.69806 18.0913 1.73592 18.1578 1.78915 18.211C1.84238 18.2641 1.909 18.3019 1.98195 18.3202C2.0549 18.3386 2.13145 18.3368 2.20348 18.3152L5.83098 17.2152C6.09196 17.1358 6.32946 16.9936 6.52265 16.801L17.6451 5.67682Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.5 4.16675L15.8333 7.50008"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconPencil',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
